import { Nav, Row, Col } from 'react-bootstrap'
import React, { useContext, useState } from 'react'
import { MdClose } from 'react-icons/md'
import { GiHamburgerMenu } from 'react-icons/gi'
import { Link } from 'react-router-dom'
import { firebaseAuth } from '../../../services/firebase'
import { MigrantContext } from '../../../contexts/migrantContext'
import { AuthContext, AuthState, UserType } from '../../../contexts/authContext'
import BackButton from '../buttons/backButton'
import styles from './nav.module.css'
import { VendorContext } from '../../../contexts/vendorContext'
import { migrantMenu, vendorMenu, MenuItem } from '../../../config/menuItems'
// import CartIcon from '../shop/cartIcon'

const Navigation: React.FC = () => {
  const authContext = useContext(AuthContext)
  const migrantContext = useContext(MigrantContext)
  const vendorContext = useContext(VendorContext)

  const isUserSignedIn = authContext?.authState === AuthState.signedIn
  const migrantProfile = migrantContext?.profile
  const vendorProfile = vendorContext?.profile

  return (
    <>
      <div
        className={
          'd-none d-lg-block position-fixed' +
          (isUserSignedIn ? ` ${styles.sidebarMenuWrapper}` : '')
        }
      >
        {isUserSignedIn && (
          <SideBarMenu
            isMigrantMode={authContext?.userType === UserType.migrant}
            menuItems={
              migrantProfile
                ? migrantMenu
                : vendorProfile
                ? vendorMenu
                : undefined
            }
          />
        )}
      </div>

      <div className="d-lg-none">
        <AppBarWithDrawer
          isSignedIn={isUserSignedIn}
          isMigrantMode={authContext?.userType === UserType.migrant}
          fullName={
            migrantProfile
              ? `${migrantProfile.firstName} ${migrantProfile.lastName}`
              : vendorProfile
              ? `${vendorProfile.firstName} ${vendorProfile.lastName}`
              : undefined
          }
          avatarUrl={
            migrantProfile
              ? migrantProfile.avatarUrl
              : vendorProfile
              ? vendorProfile.avatarUrl
              : undefined
          }
          menuItems={
            migrantProfile
              ? migrantMenu
              : vendorProfile
              ? vendorMenu
              : undefined
          }
        />
      </div>
    </>
  )
}

export interface SideBarMenuProps {
  isMigrantMode: boolean
  menuItems?: MenuItem[]
}

const SideBarMenu: React.FC<SideBarMenuProps> = ({
  isMigrantMode,
  menuItems
}) => {
  return (
    <Nav
      data-testid="sidebar"
      defaultActiveKey="/"
      className={styles.sidebarMenu}
    >
      {!isMigrantMode && (
        <Nav.Link as={Link} to="/" className={styles.titleWrapper}>
          <span className={styles.title}>BigMochi</span>
        </Nav.Link>
      )}
      {menuItems?.map(navItem => {
        return (
          <Nav.Link
            key={navItem.link}
            as={Link}
            to={navItem.link}
            data-testid={`nav-link-${navItem.title}`}
          >
            <img src={navItem.iconUrl} alt={`${navItem.title} icon`} />
            <span>{navItem.title}</span>
          </Nav.Link>
        )
      })}
      <Nav.Link
        data-testid="nav-link-logout"
        className={styles.logout}
        onClick={() => {
          firebaseAuth().signOut()
        }}
      >
        <img src="/icons/icon-log-out.svg" alt="logout icon" />
        <span>Sign Out</span>
      </Nav.Link>
    </Nav>
  )
}

export interface AppBarWithDrawerProps {
  isSignedIn: boolean
  isMigrantMode: boolean
  fullName?: string
  avatarUrl?: string
  menuItems?: MenuItem[]
}

const AppBarWithDrawer: React.FC<AppBarWithDrawerProps> = ({
  isSignedIn,
  isMigrantMode,
  fullName,
  avatarUrl,
  menuItems
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Row data-testid="app-bar" className={`no-gutters ${styles.appBar}`}>
        <Col xs={3} className={styles.leftSide}>
          <BackButton
            size={20}
            rootPaths={
              isMigrantMode ? ['/'] : ['/vendor/login', '/vendor/dashboard']
            }
          />
        </Col>
        <Col xs={6} className="text-center">
          <Link to="/">
            <h1 className={styles.title}>BigMochi</h1>
          </Link>
        </Col>
        <Col xs={3} className={styles.rightSide}>
          {/* <CartIcon /> */}
          {isSignedIn && (
            <GiHamburgerMenu
              size={20}
              onClick={() => {
                setIsOpen(true)
              }}
            />
          )}
        </Col>
      </Row>

      {isSignedIn && (
        <Nav
          data-testid="app-drawer"
          className={
            styles.drawerMenu + (isOpen ? ` ${styles.drawerMenuOpen}` : '')
          }
        >
          <div>
            <Row>
              <Col xs={9}>
                <img
                  alt="user avatar"
                  className="avatar"
                  src={avatarUrl || '/profilepic.png'}
                />
              </Col>
              <Col xs={3} className={styles.closeButtonWrapper}>
                <MdClose
                  size="24"
                  onClick={() => {
                    setIsOpen(false)
                  }}
                  className="nav-mochi-close"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <h1 className={styles.username}>{fullName}</h1>
              </Col>
            </Row>
            {menuItems?.map(navItem => {
              return (
                <Nav.Link
                  key={navItem.link}
                  as={Link}
                  to={navItem.link}
                  data-testid={`nav-link-${navItem.title}`}
                  onClick={() => {
                    setIsOpen(false)
                  }}
                >
                  <img src={navItem.iconUrl} alt={`${navItem.title} icon`} />
                  <span>{navItem.title}</span>
                </Nav.Link>
              )
            })}
            <Nav.Link
              as={Link}
              to="/"
              data-testid="nav-link-logout"
              onClick={() => {
                setIsOpen(false)
                firebaseAuth().signOut()
              }}
              className={`${styles.navLink} ${styles.logout}`}
            >
              <img src="/icons/icon-log-out.svg" alt="logout icon" />
              <span>Sign Out</span>
            </Nav.Link>
          </div>
        </Nav>
      )}
    </>
  )
}

export default Navigation
